var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1735_798)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1735_798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0049 6.93355V3.42204L3.13281 1.43359V19.245L11.0049 21.3181V17.8489L6.66633 16.7489V12.9835L11.0049 14.0835V10.6566L6.66633 9.5143V5.87587L11.0049 6.93355Z",
    fill: "url(#paint0_linear_1735_798)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7866 1.43359L11.0039 3.42204V6.93355L18.7866 4.98741V1.43359Z",
    fill: "#5F1314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0039 10.6566V14.0835L15.2531 12.9835V16.7489L11.0039 17.8489V21.3181L18.7866 19.2873V8.62585L11.0039 10.6566Z",
    fill: "#5F1314"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1735_798",
    x1: 11.0049,
    y1: 11.3758,
    x2: 3.13281,
    y2: 11.3758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37384B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37384B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1735_798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.1673,
    height: 21.1673,
    fill: "white",
    transform: "translate(0.703125 0.792969)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1735_798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.1673,
    height: 21.1673,
    fill: "white",
    transform: "translate(0.484375 0.792969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusiness);
export default __webpack_public_path__ + "static/media/icon-business.abeae8772485ca907402f4a6d963090e.svg";
export { ForwardRef as ReactComponent };